import request from '@/config/request'

export default {

  searchSkinReport: function (reportCode) {
    return request({
      url: '/skin/skinreport/searchskinreport',
      method: 'get',
      params: {
        reportcode: reportCode
      }
    })
  },
  searchListSkinReport: function (mobile) {
    return request({
      url: '/skin/skinreport/searchlistskinreport',
      method: 'get',
      params: {
        mobile: mobile
      }
    })
  },
  searchLastSkinReport: function (mobile) {
    return request({
      url: '/skin/skinreport/searchlastskinreport',
      method: 'get',
      params: {
        mobile: mobile
      }
    })
  },
  searchLastSkinReport1: function (mobile) {
    return request({
      url: '/skin/skinreport/searchlastskinreport1',
      method: 'get',
      params: {
        mobile: mobile
      }
    })
  },

  searchSkinReportForTrend: function (mobile) {
    return request({
      url: '/skin/skinreport/searchskinreportfortrend',
      method: 'get',
      params: {
        mobile: mobile
      }
    })
  },
}


// WEBPACK FOOTER //
// ./src/api/skin/skinreport.js